/**
 * OPUS-913 — Card shell + collapsible Panel.
 * Ported from the Claude Design handoff (app/primitives.jsx Card,
 * app/screen-scenecontrols.jsx Panel). Right-aligned uppercase panel title.
 */
import React, { useState } from "react";
import { Icon } from "./Icon";

export function Card({ children, style = {}, pad = 0, className }) {
  return (
    <div className={className} style={{
      background: "var(--surface-1)", border: "1px solid var(--border)",
      borderRadius: "var(--r-lg)", overflow: "hidden", padding: pad, ...style,
    }}>
      {children}
    </div>
  );
}

/** Collapsible section panel — header has an optional left `right` slot, a
 *  right-aligned uppercase title, and a chevron that rotates when open. */
export function Panel({ title, children, defaultOpen = true, right, style = {} }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ borderBottom: "1px solid var(--border)", ...style }}>
      <button
        type="button" onClick={() => setOpen((o) => !o)}
        style={{ display: "flex", alignItems: "center", width: "100%", padding: "14px 16px", background: "transparent", border: "none", cursor: "pointer" }}
      >
        {right}
        <span style={{ marginLeft: right ? 10 : 0, flex: 1, textAlign: "right", fontSize: 12.5, fontWeight: 700, color: "var(--text-muted)", letterSpacing: "0.08em" }}>{title}</span>
        <Icon name="chevronDown" size={16} style={{ color: "var(--text-dim)", marginLeft: 10, transform: open ? "none" : "rotate(-90deg)", transition: "transform .15s" }} />
      </button>
      {open && <div style={{ padding: "0 16px 18px" }}>{children}</div>}
    </div>
  );
}

/** Read-only labelled value box (Scene Controls clock + caption-data fields). */
export function FieldBox({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: "var(--text-dim)", marginBottom: 5 }}>{label}</div>
      <div style={{ padding: "10px 12px", background: "var(--surface-2)", border: "1px solid var(--border)", borderRadius: 6, fontSize: 13, color: "var(--text)", fontFamily: "var(--font-mono)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value}</div>
    </div>
  );
}

export default Card;
